import { useMemo } from 'react';

import { useCustomColumns } from '../models/queries';

/**
 * The org's custom columns as variable pills (inserted as {key} / {{key}} by VariableInserter).
 * @returns {Array<{name: string, label: string, fallbackPlaceholder?: string}>}
 */
export function useCustomColumnVariables() {
	const { data: customColumns = [] } = useCustomColumns();
	return useMemo(
		() =>
			customColumns.map((column) => ({
				name: column.key,
				label: column.name,
				fallbackPlaceholder: column.fallback ?? undefined,
			})),
		[customColumns],
	);
}

/**
 * Variable pills for a template editor: the editor's built-in variables followed by the org's
 * custom columns.
 * @param {Array<{name: string, label: string, fallbackPlaceholder?: string}>} builtIns
 * @returns {Array<{name: string, label: string, fallbackPlaceholder?: string}>}
 */
export function useTemplateVariables(builtIns) {
	const customVariables = useCustomColumnVariables();
	return useMemo(() => [...builtIns, ...customVariables], [builtIns, customVariables]);
}
